import { apiSlice } from "../../../app/service/Service";

export const userForgotPassSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        // forgotPassword: builder.mutation({
        //     query: (email, ...body) => ({
        //         url: `Account/ForgotPassword?email=${email}`,
        //         method: "POST",
        //         body
        //     }),
        // }),

        forgotPassword: builder.mutation({
            query(data) {
                const { email, ...body } = data;
                return {
                    url: `Account/ForgotPassword?email=${email}`,
                    method: "POST",
                    body
                }
            }
        }),
        
    })
})

export const { useForgotPasswordMutation } = apiSlice;

